import { useSelector } from "@xstate/store/react";

import { codeEditorStore } from "./code-editor.store";

export const useSendToCodeEditorStore = () => codeEditorStore.send;

export const useCodeEditorStore = () => useSelector(codeEditorStore, (state) => state.context);

export const useIsCodePaneOpen = () => useSelector(codeEditorStore, (state) => state.context.open);

export const useActiveTabCellID = (pageId: string) =>
	useSelector(codeEditorStore, (state) => state.context.currentTab[pageId]);

export const useSelectTabDraft = (cellID: string) =>
	useSelector(codeEditorStore, (state) => state.context.tabDrafts[cellID]);

export const useSelectPageTabs = (pageId: string) =>
	useSelector(codeEditorStore, (state) => state.context.tabs[pageId]);

export const useSelectTabDrafts = () =>
	useSelector(codeEditorStore, (state) => state.context.tabDrafts);

export const useSelectPinnedTabs = (pageId: string) =>
	useSelector(codeEditorStore, (state) => state.context.pinnedTabs[pageId]);

export const useSelectFlexTab = (pageId: string) =>
	useSelector(codeEditorStore, (state) => state.context.flexTab[pageId]);

export const useSelectActiveTab = (pageId: string) =>
	useSelector(codeEditorStore, (state) => state.context.currentTab[pageId]);
